const branding = {
  header: 'Encabezado',
  backgroundColor: 'Color de fondo',
  textColor: 'Color del texto',
  button: 'Botón',
};

export default branding;
